import React, { useState, useRef, useEffect } from "react";
import _ from "lodash";
import RetailDesignationForm from "./RetailDesignationsForm";
import LdnDesignationForm from "./LdnDesignationForm";
import Gsk from "~/images/GSK.png";

const GskDesignations = ({ entities, setCompletedDesignations }) => {
  const manufacturer = "glaxosmithkline";
  const manufacturerName = "GlaxoSmithKline";
  const [retailHasSelectedSpecialtyPharmacy, setRetailHasSelectedSpecialtyPharmacy] =
    useState(false);
  const [retailSelectedSpecialtyPharmacy, setRetailSelectedSpecialtyPharmacy] = useState();
  const [manufacturerFormDetails, setManufacturerFormDetails] = useState({
    glaxosmithkline: {},
  });

  useEffect(() => {
    setCompletedDesignations(isComplete());
  }, [manufacturerFormDetails]);

  const sharedProps = {
    entities,
    manufacturer,
    manufacturerName,
    manufacturerFormDetails,
    setManufacturerFormDetails,
    retailSelectedSpecialtyPharmacy,
    retailHasSelectedSpecialtyPharmacy,
  };

  const renderDesignationForm = (Component, specialtyKeyName) => (
    <Component
      {...sharedProps}
      isBlocked={_.some(entities, (e) => e.blocked.includes(specialtyKeyName))}
      productName={specialtyKeyName}
    />
  );

  const isComplete = () => {
    var completed = true;

    var openForms = _.map(manufacturerFormDetails, (manufacturer) => {
      return _.filter(manufacturer, (form) => {
        return form.open;
      });
    });

    // remove empty arrays and flatten
    var filteredForms = openForms.filter((e) => e.length).flat();

    if (filteredForms.length) {
      completed = _.every(filteredForms, ["completed", true]);
    }

    return completed;
  };

  return (
    <div>
      <div className="designation_form__section__header">
        <div className="designation_form__section__header__logo">
          <img src={Gsk} />
        </div>
        <div className="designation_form__section__header__title">{manufacturerName}</div>
      </div>
      {renderDesignationForm(RetailDesignationForm, "retail")}
      {renderDesignationForm(LdnDesignationForm, "benlysta")}
      {renderDesignationForm(LdnDesignationForm, "zejula")}
      {renderDesignationForm(LdnDesignationForm, "nucala")}
      {renderDesignationForm(LdnDesignationForm, "ojjaara")}
      {renderDesignationForm(LdnDesignationForm, "exdensur")}
    </div>
  );
};

export default GskDesignations;
